<template>
  <main>
    <div class="login-panel">
      <h3 class="login-title">LOGIN</h3>
      <p class="login-sub">Not Registered? <router-link to="/register">Create an Account</router-link></p>

      <form @submit.prevent="login">
        <div class="mb-3">
          <label for="username" class="form-label">Username</label>
          <input v-model="username" type="text" id="username" name="xalor_login_username" class="form-control" autocomplete="username" required>
        </div>

        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input v-model="password" type="password" id="password" class="form-control" required>
        </div>

        <button type="submit" class="btn-login">LOGIN</button>

        <p class="login-links">
          Forgot your password? <router-link to="/account/request-password-reset">Reset your password</router-link>
        </p>
        <p class="login-links">
          Having trouble logging in? <a href="https://discord.gg/xalor">Join Discord</a>
        </p>
      </form>
    </div>
  </main>
</template>

<script>
import APIClient from '@/services/APIClient.js'
// import VueHcaptcha from '@hcaptcha/vue3-hcaptcha'

export default {
  components: {
    // VueHcaptcha
  },
  created() {
    document.title = 'Login - Xalor'

    this.apiClient = new APIClient()
  },
  data() {
    return {
      apiClient: null,
      username: '',
      password: ''
    }
  },
  computed: {
    errors() {
      return this.$store.state.loginErrors;
    }
  },
  methods: {
    onVerify(tokenStr, ekey) {
      this.$store.dispatch('authenticate', {
        username: this.username,
        password: this.password
      })
    },
    login() {
      // this.$refs.hcaptcha.execute()
      this.$store.dispatch('authenticate', {
        username: this.username,
        password: this.password
      })
    }
  }
}
</script>
